import Icon from 'veui/components/Icon'
import { IconCrop } from 'dls-icons-vue'

Icon.register('crop', IconCrop)
